(() => {
  const instances = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const syncVideos = root => {
    root.querySelectorAll('[data-featured-rooms-video]').forEach(video => {
      const photo = video.closest('[data-featured-rooms-photo]');
      if (reducedMotion.matches || photo?.hidden) {
        video.pause();
        return;
      }
      video.play().catch(() => {});
    });
  };

  const activate = (root, tab, shouldFocus = false) => {
    if (!tab) return;
    const roomId = tab.dataset.roomId;

    root.querySelectorAll('[data-featured-rooms-tab]').forEach(candidate => {
      const selected = candidate === tab;
      candidate.classList.toggle('is-active', selected);
      candidate.setAttribute('aria-selected', String(selected));
      candidate.tabIndex = selected ? 0 : -1;
    });

    root.querySelectorAll('[data-featured-rooms-panel]').forEach(panel => {
      panel.hidden = panel.dataset.roomId !== roomId;
    });

    root.querySelectorAll('[data-featured-rooms-photo]').forEach(photo => {
      photo.hidden = photo.dataset.roomId !== roomId;
    });

    syncVideos(root);

    if (shouldFocus) tab.focus();
  };

  const initialize = root => {
    instances.get(root)?.abort();
    const controller = new AbortController();
    const tabs = [...root.querySelectorAll('[data-featured-rooms-tab]')];

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(root, tab), { signal: controller.signal });
      tab.addEventListener('keydown', event => {
        let nextIndex = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else if (event.key === 'Enter' || event.key === ' ') nextIndex = index;
        else return;

        event.preventDefault();
        activate(root, tabs[nextIndex], true);
      }, { signal: controller.signal });
    });

    document.addEventListener('shopify:block:select', event => {
      const blockId = CSS.escape(event.detail.blockId);
      const panel = root.querySelector(`[data-block-id="${blockId}"]`);
      if (!panel) return;
      activate(root, root.querySelector(`[data-featured-rooms-tab][data-room-id="${blockId}"]`));
    }, { signal: controller.signal });

    reducedMotion.addEventListener('change', () => syncVideos(root), { signal: controller.signal });

    instances.set(root, controller);
    root.dataset.initialized = 'true';
    syncVideos(root);
  };

  const initializeAll = scope => {
    if (scope.matches?.('[data-featured-rooms]')) initialize(scope);
    scope.querySelectorAll?.('[data-featured-rooms]').forEach(initialize);
  };

  initializeAll(document);

  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.matches?.('[data-featured-rooms]')
      ? event.target
      : event.target.querySelector?.('[data-featured-rooms]');
    instances.get(root)?.abort();
    if (root) instances.delete(root);
  });
})();
